module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/hello-bg-763c4f6656a3dcb5aa07df316dbec0ff.png";